import * as React from 'react';
import { connect } from 'react-redux';
import '../assets/css/home.css';
import { RouteComponentProps } from 'react-router';
import appConfigs from '../../../../config.json';
import Footer from '../Footer';
import Header from '../Header';
 
type thisProps = RouteComponentProps;
interface PageState {
  showComponenrt: boolean;
  SelectedTabValue: string;


}

class Home extends React.Component<thisProps, PageState> {
  constructor(props) {
    super(props);
    this.state = {
      showComponenrt: false,
      SelectedTabValue: "1",

    };
  }
  public async componentDidMount() {
    document.title =  appConfigs.CompanyTitle;

  }

  public render() {
    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
      this.setState({ SelectedTabValue: newValue });
    };
    /*  const [name, setName] = useState("555"); */
    //  const userJwt = useSelector((state: IAppState) => state.UserState?state.UserState.jwt:null); -fluid-inner
    return (
      <div dir='ltr' >
         
     <Header />
        <section id="hero" className="hero f-flex align-items-center">
        <section   id="herow" className="f-flex flex-column justify-content-end align-items-center">
   
 

 </section>

          <div className="container">
            <div className="row">
            <div className="col-lg-7 hero-img" data-aos="zoom-out" data-aos-delay="200">
                <img src={require("../assets/img/trtl.png")} className="img-dfluid" style={{width:"99%"}} alt="" />
              </div>
              <div className="col-lg-5 f-flex flex-column ">
                <h1 data-aos="fade-up" className='slogan'  style={{whiteSpace:"nowrap"}}> راهکار هوشمند کسب و کار
                  

                </h1>
            
              </div>
            
            </div>
          </div> 
      
        </section>
        <main id="main">
 
          <section id="about" className="about">
            <div className="container" data-aos="fade-up">
              <div className="row gx-0">
                <div className="col-lg-7 f-flex flex-column justify-content-center" data-aos="fade-up" data-aos-delay="200">
                  <div className="content">
                   
                    <h3> شرکت  تجارت الکترونیک هوشمند تمدن
</h3>
<span style={{fontSize:"13px",paddingRight:"5px",paddingTop:"3px"}}> 
(دانش بنیان)</span>

                    <h2> </h2>
                    <p>
                      متشکل از تیمی نخبه و جوانانی متخصص در حوزه فناوری اطلاعات، بازار سرمایه و سیستم بانکی است که راهکارها و حل مشکلات نهادهای مالی، شرکت ها، کارگزاری ها، صندوق های سرمایه گذاری و ... را در خصوص حوزه پرداخت فراهم کرده است.

                    </p>
                    <div className="text-center text-lg-start">
                      <a href="https://tamadonsec.ir/about" className="btn-read-more d-inline-flex align-items-center justify-content-center align-self-center">
                        <span>بیشتر</span>
                        <i className="bi bi-arrow-right"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-5 f-flex align-items-center" data-aos="zoom-out" data-aos-delay="200">
                  <img src={require("../assets/img/about-1.png")} className="img-fluid about-img"   alt="" />
                </div>
              </div>
              <div>
                
  
              </div>
            </div>
          </section>

          <section id="clients" className="clients">

<div className="container" data-aos="fade-up">

  <header className="section-header">
    <p>بانک های متصل</p>
    <h2>در حال حاضر به بانک های زیر متصل می باشد</h2>
  </header>

  <div className="clients-slider swiper">
    <div className="swiper-wrapper align-items-center">
      <div className="swiper-slide"><img src={require("../assets/img/banks/n-bank-shahr.png")} className="img-fluid" alt="" /></div>
      <div className="swiper-slide"><img src={require("../assets/img/banks/n-bank-tejarat.png")} className="img-fluid" alt="" /></div>
      <div className="swiper-slide"><img src={require("../assets/img/banks/n-bank-keshavarzi.png")} className="img-fluid" alt="" /></div>
      <div className="swiper-slide"><img src={require("../assets/img/banks/n-bank-tosee.png")} className="img-fluid" alt="" /></div>
      <div className="swiper-slide"><img src={require("../assets/img/banks/n-bank-sina.png")} className="img-fluid" alt="" /></div>
      <div className="swiper-slide"><img src={require("../assets/img/banks/n-bank-saderat.png")} className="img-fluid" alt="" /></div>
      <div className="swiper-slide"><img src={require("../assets/img/banks/n-bank-pasargad.png")} className="img-fluid" alt="" /></div>
    </div>
    <div className="swiper-pagination"></div>
  </div>
</div>

</section>


          <section id="counts" className="counts">
            <div className="container" data-aos="fade-up">

              <div className="row gy-4">
                <div className="col-lg-4 col-md-6">
                  <div className="count-box">
                    <img src={require("../assets/img/count.png")} className="img-fluid" style={{ maxWidth: "50%" }} alt="" />

                     <span data-purecounter-start="0" data-purecounter-end="+259" data-purecounter-duration="1" className="purecounter"></span>
                    همت
                    <p>  تراکنش
                    </p>
                  </div>

                </div>

                <div className="col-lg-4 col-md-6">
                  <div className="count-box">
                    <img src={require("../assets/img/amount.png")} className="img-fluid" style={{ maxWidth: "50%" }} alt="" />



                    <span data-purecounter-start="0" data-purecounter-end="17" data-purecounter-duration="1" className="purecounter">
+9
                    </span>
                    میلیون


                    <p>
                      تراکنش
                    </p>



                  </div>
                </div>

                <div className="col-lg-4 col-md-6">
                  <div className="count-box">

                    <img src={require("../assets/img/rate.png")} className="img-fluid" style={{ maxWidth: "50%" }} alt="" />
                     <span data-purecounter-start="0" data-purecounter-end="98.9" data-purecounter-duration="1" className="purecounter">+98.9</span>
                    درصد
                    <p> موفقیت در تراکنش ها
                    </p>



                  </div>
                </div>




              </div>

            </div>
          </section>


          <section id="clients" className="clients">

            <div className="container" data-aos="fade-up">

              <header className="section-header">
                <p>   مشتریان ما  </p>
                <h2> به جمع مشتریان ما بپیوندید    </h2>
              </header>

              <div className="clients-slider swiper">
                <div className="swiper-wrapper align-items-center">
                  <div className="swiper-slide"><img src={require("../assets/img/clients/c6.png")} className="img-fluid" alt="" /></div>
                  <div className="swiper-slide"><img src={require("../assets/img/clients/c5.png")} className="img-fluid" alt="" /></div>
                  <div className="swiper-slide"><img src={require("../assets/img/clients/c4.png")} className="img-fluid" alt="" /></div>
                  <div className="swiper-slide"><img src={require("../assets/img/clients/c3.png")} className="img-fluid" alt="" /></div>
                  <div className="swiper-slide"><img src={require("../assets/img/clients/c2.png")} className="img-fluid" alt="" /></div>
                </div>
                <div className="swiper-pagination"></div>
              </div>
            </div>

          </section>
  

        </main>
        <Footer />
      </div>
    );
  };
}
export default connect()(Home);
